import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFileAlt from '@fortawesome/fontawesome-free-regular/faFileAlt';
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt';

import Item from '../../../../models/Item';
import { AttachmentType } from '../../../../config/constants';
import AttachmentUploader from '../../../common/AttachmentUploader';
import InfoBox from '../../../common/InfoBox';
import AttachmentImage from './AttachmentImage';
import formPropsType from '../../../common/types/formPropsType';
import Button from '../../../common/Button';
import './Attachments.css';

class Attachments extends PureComponent {
  render() {
    const { item, formProps } = this.props;

    const images = item.attachments.filter(a => a.type === AttachmentType.IMAGE);
    const documents = item.attachments.filter(a => a.type !== AttachmentType.IMAGE);

    const uploadCallback = (results) => {
      formProps.setFieldValue('attachments', [...item.attachments, ...results]);
      formProps.handleSubmit();
    };

    const onDeleteAttachment = (attachment) => {
      const atts = item.attachments.filter((att) => {
        return att.id !== attachment.id;
      });

      formProps.setFieldValue('attachments', atts);
      formProps.handleSubmit();
    };

    return (
      <div className="attachmentsGrid">
        <InfoBox
          title={`Images (${images.length})`}
          titleRight={
            <AttachmentUploader attType={AttachmentType.IMAGE} onSuccess={uploadCallback} />
          }
        >
          <div className="columns is-multiline">
            {images.map(a => (
              <div className="column is-one-quarter is-one-third-tablet" key={a.id}>
                <div style={{
                  position: 'relative',
                }}
                >
                  <figure style={{ textAlign: 'center' }} >
                    <a href={a.path} target="_blank">
                      <AttachmentImage imgSrc={a.thumbnailPath} alt={a.originalFileName} />
                    </a>
                    <figcaption>
                      <a href={a.path} target="_blank">
                        { a.originalFileName}
                      </a>
                      <Button
                        style={{ 'margin-left': '5px' }}
                        size="small"
                        type="button"
                        color="danger"
                        handler={() => {
                          onDeleteAttachment(a);
                        }}
                        title="Delete this image"
                        isDisabled={formProps.isSubmitting}
                        label={
                          <FontAwesomeIcon icon={faTrashAlt} className="icon" fixedWidth />}
                      />
                    </figcaption>
                  </figure>
                </div>
              </div>
            ))}
          </div>
        </InfoBox>

        <InfoBox
          title={`Documents (${documents.length})`}
          titleRight={
            <AttachmentUploader attType={AttachmentType.ITEM} onSuccess={uploadCallback} />
          }
        >
          <div className="columns is-multiline">
            {documents.map(a => (
              <div className="column" key={a.id}>
                <figure style={{ textAlign: 'center' }}>
                  <a href={a.path} target="_blank">
                    <FontAwesomeIcon icon={faFileAlt} size="3x" />
                  </a>
                  <figcaption>
                    <a href={a.path} target="_blank">
                      { a.originalFileName}
                    </a>
                    <Button
                      style={{ 'margin-left': '5px' }}
                      size="small"
                      type="button"
                      color="danger"
                      handler={() => {
                          onDeleteAttachment(a);
                        }}
                      title="Delete this image"
                      isDisabled={formProps.isSubmitting}
                      label={
                        <FontAwesomeIcon icon={faTrashAlt} className="icon" fixedWidth />}
                    />
                  </figcaption>
                </figure>
              </div>
            ))}
          </div>
        </InfoBox>
      </div>
    );
  }
}

Attachments.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  formProps: formPropsType.isRequired,
};

export default Attachments;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Attachments.jsx